// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wj_a bib_b"};